import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {DxBaseUiOptions} from "../dx-base-ui-options";

/**
 * Опции компонента dx-page (базовой разметки страницы).
 * @publicApi
 */
@jsonObject
export class DxPageOptions extends DxBaseUiOptions {
  /**
   * Флаг скрытия\показа боковой панели страницы.
   * @name _withoutPageSide
   * @type {boolean}
   */
  @jsonMember({name: "withoutPageSide", constructor: Boolean, emitDefaultValue: true, isRequired: false})
  private _withoutPageSide: boolean = true;

  /**
   * Массив дополнительных стилей для обертывающего контейнера страницы (дополнительные к `.dx-page {...}`).
   * @name _pageStyles
   * @type {string[]}
   */
  @jsonArrayMember(String, {name: 'pageStyles', isRequired: false, emitDefaultValue: false})
  private _pageStyles: string[];

  /**
   * Массив дополнительных стилей для контейнера под шапку страницы (дополнительные к `.dx-page__header {...}`).
   * @name _pageHeaderStyles
   * @type {string[]}
   */
  @jsonArrayMember(String, {name: 'pageHeaderStyles', isRequired: false, emitDefaultValue: false})
  private _pageHeaderStyles: string[] = [];

  /**
   * Массив дополнительных стилей для контейнера под боди страницы (дополнительные к `.dx-page__body {...}`).
   * @name _pageBodyStyles
   * @type {string[]}
   */
  @jsonArrayMember(String, {name: 'pageBodyStyles', isRequired: false, emitDefaultValue: false})
  private _pageBodyStyles: string[] = [];

  /**
   * Массив дополнительных стилей для контейнера под боковую панель страницы (дополнительные к `.dx-page__side {...}`).
   * @name _pageSideStyles
   * @type {string[]}
   */
  @jsonArrayMember(String, {name: 'pageSideStyles', isRequired: false, emitDefaultValue: false})
  private _pageSideStyles: string[] = [];

  /**
   * Массив дополнительных стилей для контейнера под контент страницы (дополнительные к `.dx-page__content {...}`).
   * @name _pageContentStyles
   * @type {string[]}
   */
  @jsonArrayMember(String, {name: 'pageContentStyles', isRequired: false, emitDefaultValue: false})
  private _pageContentStyles: string[] = [];

  /**
   * Массив дополнительных стилей для контейнера под футер страницы (дополнительные к `.dx-page__footer {...}`).
   * @name _pageContentStyles
   * @type {string[]}
   */
  @jsonArrayMember(String, {name: 'pageFooterStyles', isRequired: false, emitDefaultValue: false})
  private _pageFooterStyles: string[] = [];


  /**
   * Возвращает флаг скрытия\показа боковой панели страницы.
   * @return {boolean} - флаг скрытия\показа боковой панели страницы.
   */
  get withoutPageSide(): boolean {
    return this._withoutPageSide;
  }

  /**
   * Устанавливает флаг скрытия\показа боковой панели страницы.
   * @param {boolean} value - флаг скрытия\показа боковой панели страницы.
   */
  set withoutPageSide(value: boolean) {
    this._withoutPageSide = value;
  }

  get pageStyles(): string[] {
    return this._pageStyles;
  }

  set pageStyles(value: string[]) {
    this._pageStyles = value;
  }

  get pageHeaderStyles(): string[] {
    return this._pageHeaderStyles;
  }

  set pageHeaderStyles(value: string[]) {
    this._pageHeaderStyles = value;
  }

  get pageBodyStyles(): string[] {
    return this._pageBodyStyles;
  }

  set pageBodyStyles(value: string[]) {
    this._pageBodyStyles = value;
  }

  get pageSideStyles(): string[] {
    return this._pageSideStyles;
  }

  set pageSideStyles(value: string[]) {
    this._pageSideStyles = value;
  }

  get pageContentStyles(): string[] {
    return this._pageContentStyles;
  }

  set pageContentStyles(value: string[]) {
    this._pageContentStyles = value;
  }

  get pageFooterStyles(): string[] {
    return this._pageFooterStyles;
  }

  set pageFooterStyles(value: string[]) {
    this._pageFooterStyles = value;
  }
}
